// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g7nA","colBig":"styles_colBig__107eQ","colSmall":"styles_colSmall__2F4I6"};